import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initRum } from "./rum";
import { initGa } from "./ga";
import { installAudioUnlock } from "./audioUnlock";

// Frontend RUM + session replay (ADR 0086) — env-gated + lazy; a no-op unless
// window.__RUM__ (from /rum.js) configures Faro and/or OpenReplay.
initRum();

// Google Analytics 4 (ADR 0224) — same served runtime config (window.__RUM__.ga4Id
// from /rum.js), lazy-loaded; a no-op unless a measurement id is configured.
// page_view is sent per route by useGaPageViews (App), not gtag's auto-send.
initGa();

// Fan-watch audio unlock (LSC-638): resume the app-wide AudioContext inside the first
// tap anywhere, so a Watch opened later (home → Cave → Watch) is audible on iOS.
installAudioUnlock();

const CAVE_IMG = "/cave-background.jpg";

/**
 * Fixed cave photograph behind everything (ADR 0018). It's a large JPEG, so we
 * decode it fully off-screen first and only then fade it in — otherwise the
 * browser paints it top-to-bottom as it streams, which reads as an annoying
 * "wipe" sliding down the page (ADR 0021 fix). Until it's ready the page shows
 * the stone canvas; pages opt into the photo with .mer-canvas--photo.
 */
function CaveBackground() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const img = new Image();
    img.src = CAVE_IMG;
    const show = () => setReady(true);
    // decode() resolves once the bitmap is fully ready to paint (no wipe);
    // fall back to onload where decode isn't available.
    if (typeof img.decode === "function") {
      img.decode().then(show, show);
    } else {
      img.onload = show;
      img.onerror = show;
    }
  }, []);
  return (
    <div
      className="cave-bg"
      aria-hidden="true"
      style={{
        ["--cave-img" as string]: `url(${CAVE_IMG})`,
        opacity: ready ? 1 : 0,
        transition: "opacity 0.45s ease",
      }}
    />
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <CaveBackground />
    <App />
  </React.StrictMode>,
);
